import api from "./axios";

// Module 1's frozen auth surface (`functions/src/routers/authRoutes.js`), mounted at `/auth`.
//
// NOTE ON THE TEMPLATE. §6 shows `GET /auth/admin/check`. This backend's equivalent is `GET /auth/me`
// — Module 1 is FROZEN and its routes are `/auth/login`, `/auth/logout`, `/auth/me` and
// `/auth/change-password`. The template's own §0.2 rule is what matters and is honoured exactly:
// "the server is the only authority on identity", asked on every boot. Only the path differs, because
// inventing `/auth/admin/check` would mean modifying a frozen module to satisfy a document.
//
// ⚠ RESOLVES TO `{ user, mustChangePassword }`, NOT TO THE USER. `authService.getCurrentUser` nests
// the account under `user` and carries the forced-change flag alongside it. Callers must destructure;
// spreading this payload as if it were the account silently yields `designation: undefined`.
export const checkAuth = () => api.get("/auth/me").then((r) => r.data.data);

// Part 3 BD-7: the admin panel signs in STAFF accounts only; the API refuses a customer account here.
export const login = (email, password) =>
  api.post("/auth/login", { email, password, audience: "staff" }).then((r) => r.data);

export const logout = () => api.post("/auth/logout").then((r) => r.data);

export const changePassword = (currentPassword, newPassword) =>
  api.post("/auth/change-password", { currentPassword, newPassword }).then((r) => r.data);
